import React from "react";
import { Link } from "react-router-dom";

import logoBanner from '../assets/SYM_email_banner_speechBubble.svg';
import '../styles/footer.css';

const SOCIAL_LINKS = [
  {
    href: "https://www.facebook.com/profile.php?id=61561519431741",
    label: "Facebook",
    icon: (
      <path d="M400 32H48A48 48 0 0 0 0 80v352a48 48 0 0 0 48 48h137.25V327.69h-63V256h63v-54.64c0-62.15 37-96.48 93.67-96.48 27.14 0 55.52 4.84 55.52 4.84v61h-31.27c-30.81 0-40.42 19.12-40.42 38.73V256h68.78l-11 71.69h-57.78V480H400a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z" />
    ),
  },
  {
    href: "https://www.linkedin.com/company/speak-your-menu",
    label: "LinkedIn",
    icon: (
      <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" />
    ),
  },
  {
    href: "https://www.instagram.com/speakyourmenu/",
    label: "Instagram",
    icon: (
      <path d="M224,202.66A53.34,53.34,0,1,0,277.36,256,53.38,53.38,0,0,0,224,202.66Zm124.71-41a54,54,0,0,0-30.41-30.41c-21-8.29-71-6.43-94.3-6.43s-73.25-1.93-94.31,6.43a54,54,0,0,0-30.41,30.41c-8.28,21-6.43,71.05-6.43,94.33S91,329.26,99.32,350.33a54,54,0,0,0,30.41,30.41c21,8.29,71,6.43,94.31,6.43s73.24,1.93,94.3-6.43a54,54,0,0,0,30.41-30.41c8.35-21,6.43-71.05,6.43-94.33S357.1,182.74,348.75,161.67ZM224,338a82,82,0,1,1,82-82A81.9,81.9,0,0,1,224,338Zm85.38-148.3a19.14,19.14,0,1,1,19.13-19.14A19.1,19.1,0,0,1,309.42,189.74ZM400,32H48A48,48,0,0,0,0,80V432a48,48,0,0,0,48,48H400a48,48,0,0,0,48-48V80A48,48,0,0,0,400,32ZM382.88,322c-1.29,25.63-7.14,48.34-25.85,67s-41.4,24.63-67,25.85c-26.41,1.49-105.59,1.49-132,0-25.63-1.29-48.26-7.15-67-25.85s-24.63-41.42-25.85-67c-1.49-26.42-1.49-105.61,0-132,1.29-25.63,7.07-48.34,25.85-67s41.47-24.56,67-25.78c26.41-1.49,105.59-1.49,132,0,25.63,1.29,48.33,7.15,67,25.85s24.63,41.42,25.85,67.05C384.37,216.44,384.37,295.56,382.88,322Z" />
    ),
  },
];

const FOOTER_LINKS = [
  { type: "route", href: "/terms", label: "Terms of Service" },
  { type: "route", href: "/privacy", label: "Privacy Policy" },
  { type: "route", href: "/contact", label: "Contact" },
  { type: "anchor", href: "/admin/login", label: "Admin" },
];

function FooterSocialLinks({ className = "", linkClassName = "" }) {
  return (
    <div className={className}>
      {SOCIAL_LINKS.map((item) => (
        <a
          key={item.label}
          className={linkClassName}
          target="_blank"
          rel="noopener noreferrer"
          href={item.href}
          aria-label={item.label}
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="1.15em" height="1.15em" fill="currentColor" aria-hidden="true">
            {item.icon}
          </svg>
        </a>
      ))}
    </div>
  );
}

function FooterNavLinks({ className = "", linkClassName = "", onNavigate }) {
  return (
    <div className={className}>
      {FOOTER_LINKS.map((item) => {
        if (item.type === "route") {
          return (
            <Link key={item.label} to={item.href} onClick={onNavigate} className={linkClassName}>
              {item.label}
            </Link>
          );
        }

        return (
          <a key={item.label} href={item.href} onClick={onNavigate} className={linkClassName} aria-label={item.label}>
            {item.label}
          </a>
        );
      })}
    </div>
  );
}

function FooterBrandBlock({ description, eyebrow }) {
  return (
    <div className="footer-brand-block">
      {eyebrow ? <p className="footer-brand-eyebrow">{eyebrow}</p> : null}
      <img alt="Speak Your Menu logo" className="footer-brand-logo" src={logoBanner} />
      <p className="footer-brand-copy">
        Copyright © <span>Speak Your Menu</span> 2026
      </p>
      {description ? <p className="footer-brand-description">{description}</p> : null}
    </div>
  );
}
function Footer() {

  // Ensure footer links always take users to the top of the destination page
  const scrollToTop = () => {
    try {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    } catch (_) {
      // fallback for older browsers
      window.scrollTo(0, 0);
    }
  };

  return (
    <section className="footer footer-editorial-shell">
      <div className="footer-preview-editorial footer-preview-editorial-live">
        <div className="footer-preview-editorial-topline" aria-hidden="true" />
        <div className="footer-preview-editorial-grid">
          <FooterBrandBlock description="A structured menu training platform for faster onboarding and stronger retention." />
          <div className="footer-preview-editorial-side">
            <div className="footer-preview-link-groups">
              <div>
                <p className="footer-preview-group-label">Company</p>
                <FooterNavLinks className="footer-preview-link-column" linkClassName="footer-preview-column-link" onNavigate={scrollToTop} />
              </div>
            </div>
            <FooterSocialLinks className="footer-preview-socials footer-preview-socials-inline" linkClassName="footer-preview-social-link footer-preview-social-link-muted" />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Footer;
